/* eslint-disable import/prefer-default-export */

// import React from 'react';
import styled from 'styled-components';

import Radio from 'antd/lib/radio';

const RadioGroup = styled(Radio.Group)`
  width: 100%;
  display: flex;
  > .ant-radio-button-wrapper {
    width: 100%;
    text-align: center;
  }
`;

export const filterCompare = ['FilterField', {
  id: 'compare',
  label: null,
  section: 'topHeader',
  buildQuery: (value, builder) => value && value.length && builder.add(
    'custom',
    { compare: `${value}` },
  ),
  getValueForField: value => (
      value && value.length
    ? value
    : '0'
  ),
  field: ['FieldRadio', {
    Component: RadioGroup,
    name: 'compare',
    placeholder: 'Mode',
    showArrow: true,
    optionFilterProp: 'children',
    choices: [{
      value: '0',
      label: 'Single',
    }, {
      value: '1',
      label: 'Compare A',
    }, {
      value: '2',
      label: 'Compare B',
    }],
  }],
  col: {
    lg: { span: 24 },
    xs: { span: 24 },
  },
}];
